export default "__VITE_ASSET__26716ee8__"